module.exports = __webpack_public_path__ + "images/psp/FeaturedContentImages/electricity-video-content-2.png";